import SingleBarChart from "@/components/visualizations/SingleBarChart.tsx/SingleBarChart";
import TreeMapChart from "@/components/visualizations/TreeMapChart/TreeMapChart";
import { colorPalettes } from "@/components/visualizations/useVisualization";
import useUrlState from "@/hooks/useUrlState";
import { formatCarbonFootprint } from "../utils/formatters";
import styles from "./GhgDashboard.module.scss";
import { IGetGhg, scopes } from "./types";

const colorFormatter = (label?: string) => {
  if (label?.includes("Scope 1")) return colorPalettes["scope"].normal[0];
  if (label?.includes("Scope 2")) return colorPalettes["scope"].normal[1];
  if (label?.includes("Scope 3")) return colorPalettes["scope"].normal[2];
  return "#fff";
};

const fontColorFormatter = (label?: string) => {
  if (label?.includes("Scope 1")) return colorPalettes["scope"].font[0];
  if (label?.includes("Scope 2")) return colorPalettes["scope"].font[1];
  if (label?.includes("Scope 3")) return colorPalettes["scope"].font[2];
  return "#fff";
};

export default function GhgTreemap({ data, loading }: { data?: IGetGhg; loading?: boolean }) {
  // const { startDate, endDate } = useDateRange();
  const [, setScopeKey] = useUrlState("scope_key");

  const chartData = data
    ? scopes
        .map((scope) =>
          scope.levels.map((level) => ({
            category: level.label,
            mainCategory: scope.label,
            value: data?.[level.key],
            onClick: () => setScopeKey(level.key),
          }))
        )
        .flat()
    : [];

  return (
    <>
      <div className={styles.charts}>
        <div className={styles.barChart}>
          <SingleBarChart
            loading={loading}
            format={formatCarbonFootprint}
            colorPalette={"scope"}
            data={[
              { label: "Scope 1", value: data?.scope_1 || 0 },
              { label: "Scope 2", value: data?.scope_2 || 0 },
              { label: "Scope 3", value: data?.scope_3 || 0 },
            ]}
          />
        </div>
        <div className={styles.ghgTreeMap}>
          <TreeMapChart
            data={chartData}
            loading={loading}
            labelToBackgroundColor={colorFormatter}
            labelToFontColor={fontColorFormatter}
            format={formatCarbonFootprint}
          />
        </div>
      </div>
    </>
  );
}
